import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FixedSizeList as List } from 'react-window';
import InfiniteScroll from 'react-infinite-scroll-component';

const JsonViewer = () => {
  const [jsonData, setJsonData] = useState<any[]>([]);
  const [startByte, setStartByte] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const chunkSize = 62000;

  useEffect(() => {
    fetchMoreData();
  }, []);

  const fetchMoreData = () => {
    axios.get(`https://viewer-json-api-558926418263.us-central1.run.app/json-data?chunkSize=${chunkSize}&startByte=${startByte}`)
      .then(response => {
        const { chunk, nextByte } = response.data;
        if (chunk.length === 0) {
          setHasMore(false);
        } else {
          setJsonData(prevData => [...prevData, ...chunk.split('\n').map((line: string) => line.trim()).filter((line: string) => line)]);
          setStartByte(nextByte);
        }
      })
      .catch(error => {
        console.error('Error fetching JSON data:', error);
      });
  };

  return (
    <InfiniteScroll
      dataLength={jsonData.length}
      next={fetchMoreData}
      hasMore={hasMore}
      loader={<h4>Loading...</h4>}
      endMessage={<p style={{ textAlign: 'center' }}>No more data</p>}
    >
      <List
        height={1000}
        itemCount={jsonData.length}
        itemSize={200}
        width={800}
      >
        {({ index, style }) => (
          <div style={style}>
            {jsonData[index]}
          </div>
        )}
      </List>
    </InfiniteScroll>
  );
};

export default JsonViewer;
